module.exports = __webpack_public_path__ + "img/a1-s38.743814a9.jpg";